import { render } from "./StaticPart.vue?vue&type=template&id=321c6e6f&scoped=true&bindings={\"iconsList\":\"setup\"}"
import script from "./StaticPart.vue?vue&type=script&lang=js"
export * from "./StaticPart.vue?vue&type=script&lang=js"

import "./StaticPart.vue?vue&type=style&index=0&id=321c6e6f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-321c6e6f"

export default script